export default "__VITE_ASSET__C0UOV2l9__"